
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/politica-privacidade",
      function () {
        return require("private-next-pages/legal/politica-privacidade.tsx");
      }
    ]);
  